// Banner "Modo Copa do Mundo" no topo da Visão Geral.
// Switch persiste em settings.cardapio_theme (= "copa-brasil" | "default").
// Quando ON, o cardápio público vira tema Brasil via useCopaTheme({apply:true}).
import React from "react";
import { useCopaTheme, COPA_ENABLED } from "./useCopaTheme";
import "./copa-theme.css";

// Imagem da bandeira (Wikipedia commons). Usada em vez de emoji 🇧🇷 porque
// Windows não tem fonte de emoji de bandeira — renderiza "BR" em texto.
const FLAG_BRASIL = "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Brazil.svg/330px-Flag_of_Brazil.svg.png";

export default function CopaBanner() {
  const { active, loading, toggle } = useCopaTheme();

  // Feature congelada pós-Copa 2026: banner some da Visão Geral. Revival = COPA_ENABLED.
  if (!COPA_ENABLED) return null;

  return (
    <div className={`copa-banner ${active ? "active" : ""}`} role="region" aria-label="Modo Copa do Mundo">
      <div className="copa-banner-confettis" aria-hidden />
      <div className="copa-banner-shimmer" aria-hidden />
      <div className="copa-banner-content">
        <img className="copa-banner-flag-img" src={FLAG_BRASIL} alt="" aria-hidden />
        <div className="copa-banner-text">
          <div className="copa-banner-title">
            VAMOS BRASIL! <span className="copa-banner-ball" aria-hidden>⚽</span>
          </div>
          <div className="copa-banner-subtitle">
            Modo Copa do Mundo 2026 · É HEXA DE SABOR!
          </div>
        </div>
        <img className="copa-banner-flag-img copa-banner-flag-right" src={FLAG_BRASIL} alt="" aria-hidden />
      </div>
      <button
        type="button"
        className={`copa-switch ${active ? "on" : "off"}`}
        onClick={() => !loading && toggle(!active)}
        aria-pressed={active}
        disabled={loading}
        title={active ? "Desativar modo Copa" : "Ativar modo Copa"}
      >
        <span className="copa-switch-thumb" aria-hidden />
        <span className="copa-switch-label">{active ? "ON" : "OFF"}</span>
      </button>
    </div>
  );
}
